export const SHOW_PROFILE_DRIVER_BIRTHDAY_MODAL =
  "profile/SHOW_PROFILE_DRIVER_BIRTHDAY_MODAL";
export const HIDE_PROFILE_DRIVER_BIRTHDAY_MODAL =
  "profile/HIDE_PROFILE_DRIVER_BIRTHDAY_MODAL";
export const SHOW_PROFILE_DRIVER_LICENSE_MODAL =
  "profile/SHOW_PROFILE_DRIVER_LICENSE_MODAL";
export const HIDE_PROFILE_DRIVER_LICENSE_MODAL =
  "profile/HIDE_PROFILE_DRIVER_LICENSE_MODAL";
export const SHOW_PROFILE_DRIVER_EMAIL_MODAL =
  "profile/SHOW_PROFILE_DRIVER_EMAIL_MODAL";
export const HIDE_PROFILE_DRIVER_EMAIL_MODAL =
  "profile/HIDE_PROFILE_DRIVER_EMAIL_MODAL";
export const SHOW_PROFILE_DRIVER_ADDRESS_MODAL =
  "profile/SHOW_PROFILE_DRIVER_ADDRESS_MODAL";
export const HIDE_PROFILE_DRIVER_ADDRESS_MODAL =
  "profile/HIDE_PROFILE_DRIVER_ADDRESS_MODAL";
export const SHOW_PROFILE_DRIVER_PHONE_MODAL =
  "profile/SHOW_PROFILE_DRIVER_PHONE_MODAL";
export const HIDE_PROFILE_DRIVER_PHONE_MODAL =
  "profile/HIDE_PROFILE_DRIVER_PHONE_MODAL";
export const SHOW_PROFILE_DRIVER_VEHICLE_OPTIONS_MODAL =
  "profile/SHOW_PROFILE_DRIVER_VEHICLE_OPTIONS_MODAL";
export const HIDE_PROFILE_DRIVER_VEHICLE_OPTIONS_MODAL =
  "profile/HIDE_PROFILE_DRIVER_VEHICLE_OPTIONS_MODAL";
export const SHOW_PROFILE_DRIVER_EMAIL_OPTIONS_MODAL =
  "profile/SHOW_PROFILE_DRIVER_EMAIL_OPTIONS_MODAL";
export const HIDE_PROFILE_DRIVER_EMAIL_OPTIONS_MODAL =
  "profile/HIDE_PROFILE_DRIVER_EMAIL_OPTIONS_MODAL";
export const SHOW_PROFILE_DRIVER_ADDRESS_OPTIONS_MODAL =
  "profile/SHOW_PROFILE_DRIVER_ADDRESS_OPTIONS_MODAL";
export const HIDE_PROFILE_DRIVER_ADDRESS_OPTIONS_MODAL =
  "profile/HIDE_PROFILE_DRIVER_ADDRESS_OPTIONS_MODAL";
export const SHOW_PROFILE_DRIVER_PHONE_OPTIONS_MODAL =
  "profile/SHOW_PROFILE_DRIVER_PHONE_OPTIONS_MODAL";
export const HIDE_PROFILE_DRIVER_PHONE_OPTIONS_MODAL =
  "profile/HIDE_PROFILE_DRIVER_PHONE_OPTIONS_MODAL";
export const HIDE_PROFILE_DRIVER_ADD_VEHICLE_MODAL =
  "profile/HIDE_PROFILE_DRIVER_ADD_VEHICLE_MODAL";
export const HIDE_PROFILE_DRIVER_MANAGE_VEHICLE_MODAL =
  "profile/HIDE_PROFILE_DRIVER_MANAGE_VEHICLE_MODAL";
export const SHOW_PROFILE_DRIVER_ADD_VEHICLE_MODAL =
  "profile/SHOW_PROFILE_DRIVER_ADD_VEHICLE_MODAL";
export const SHOW_PROFILE_DRIVER_MANAGE_VEHICLE_MODAL =
  "profile/SHOW_PROFILE_DRIVER_MANAGE_VEHICLE_MODAL";
export const HIDE_PROFILE_DRIVER_SELECTED_EDIT_DATA =
  "profile/HIDE_PROFILE_DRIVER_SELECTED_EDIT_DATA";
export const PROFILE_DRIVER_ADD_NEW_VEHICLE =
  "profile/PROFILE_DRIVER_ADD_NEW_VEHICLE";
export const PROFILE_DRIVER_ADD_NEW_VEHICLE_WITH_DOCUMENTS =
  "profile/PROFILE_DRIVER_ADD_NEW_VEHICLE_WITH_DOCUMENTS";
export const PROFILE_DRIVER_EDIT_VEHICLE =
  "profile/PROFILE_DRIVER_EDIT_VEHICLE";
export const PROFILE_DRIVER_ADD_NEW_EMAIL =
  "profile/PROFILE_DRIVER_ADD_NEW_EMAIL";
export const PROFILE_DRIVER_ADD_NEW_ADDRESS =
  "profile/PROFILE_DRIVER_ADD_NEW_ADDRESS";
export const PROFILE_DRIVER_ADD_NEW_BILLING_ADDRESS =
  "profile/PROFILE_DRIVER_ADD_NEW_BILLING_ADDRESS";
export const PROFILE_DRIVER_ADD_NEW_PHONE =
  "profile/PROFILE_DRIVER_ADD_NEW_PHONE";
export const PROFILE_DRIVER_EDIT_VEHICLE_API =
  "profile/PROFILE_DRIVER_EDIT_VEHICLE_API";
export const PROFILE_DRIVER_EDIT_EMAIL_API =
  "profile/PROFILE_DRIVER_EDIT_EMAIL_API";
export const PROFILE_DRIVER_DELETE_EMAIL_API =
  "profile/PROFILE_DRIVER_DELETE_EMAIL_API";
export const PROFILE_DRIVER_DELETE_VEHICLE_API =
  "profile/PROFILE_DRIVER_DELETE_VEHICLE_API";
export const PROFILE_DRIVER_EDIT_ADDRESS_API =
  "profile/PROFILE_DRIVER_EDIT_ADDRESS_API";
export const PROFILE_DRIVER_EDIT_PHONE_API =
  "profile/PROFILE_DRIVER_EDIT_PHONE_API";
export const PROFILE_DRIVER_EDIT_DOB_API =
  "profile/PROFILE_DRIVER_EDIT_DOB_API";
export const PROFILE_DRIVER_GET_STYLING_API =
  "profile/PROFILE_DRIVER_GET_STYLING_API";
export const PROFILE_DRIVER_SET_STYLING_API =
  "profile/PROFILE_DRIVER_SET_STYLING_API";

export const SHOW_PROFILE_DRIVER_DELETE_VEHICLE_MODAL =
  "profile/SHOW_PROFILE_DRIVER_DELETE_VEHICLE_MODAL";
export const SHOW_PROFILE_DRIVER_UPDATE_USERNAME_MODAL =
  "profile/SHOW_PROFILE_DRIVER_UPDATE_USERNAME_MODAL";
export const HIDE_PROFILE_DRIVER_UPDATE_USERNAME_MODAL =
  "profile/HIDE_PROFILE_DRIVER_UPDATE_USERNAME_MODAL";

export const HIDE_PROFILE_DRIVER_DELETE_VEHICLE_MODAL =
  "profile/HIDE_PROFILE_DRIVER_DELETE_VEHICLE_MODAL";
export const SHOW_PROFILE_DRIVER_EDIT_VEHICLE_MODAL =
  "profile/SHOW_PROFILE_DRIVER_EDIT_VEHICLE_MODAL";
export const HIDE_PROFILE_DRIVER_EDIT_VEHICLE_MODAL =
  "profile/HIDE_PROFILE_DRIVER_EDIT_VEHICLE_MODAL";
export const SHOW_PROFILE_DRIVER_EDIT_EMAIL_MODAL =
  "profile/SHOW_PROFILE_DRIVER_EDIT_EMAIL_MODAL";
export const SHOW_PROFILE_DRIVER_DELETE_EMAIL_MODAL =
  "profile/SHOW_PROFILE_DRIVER_DELETE_EMAIL_MODAL";
export const SHOW_PROFILE_DRIVER_DELETE_ADDRESS_MODAL =
  "profile/SHOW_PROFILE_DRIVER_DELETE_ADDRESS_MODAL";
export const HIDE_PROFILE_DRIVER_DELETE_EMAIL_MODAL =
  "profile/HIDE_PROFILE_DRIVER_DELETE_EMAIL_MODAL";
export const HIDE_PROFILE_DRIVER_EDIT_EMAIL_MODAL =
  "profile/HIDE_PROFILE_DRIVER_EDIT_EMAIL_MODAL";
export const SHOW_PROFILE_DRIVER_EDIT_ADDRESS_MODAL =
  "profile/SHOW_PROFILE_DRIVER_EDIT_ADDRESS_MODAL";
export const HIDE_PROFILE_DRIVER_EDIT_ADDRESS_MODAL =
  "profile/HIDE_PROFILE_DRIVER_EDIT_ADDRESS_MODAL";
export const SHOW_PROFILE_DRIVER_EDIT_PHONE_MODAL =
  "profile/SHOW_PROFILE_DRIVER_EDIT_PHONE_MODAL";
export const HIDE_PROFILE_DRIVER_EDIT_PHONE_MODAL =
  "profile/HIDE_PROFILE_DRIVER_EDIT_PHONE_MODAL";

export const SHOW_PROFILE_DRIVER_VEHICLE_DOCUMENTS_MODAL =
  "profile/SHOW_PROFILE_DRIVER_VEHICLE_DOCUMENTS_MODAL";
export const HIDE_PROFILE_DRIVER_VEHICLE_DOCUMENTS_MODAL =
  "profile/HIDE_PROFILE_DRIVER_VEHICLE_DOCUMENTS_MODAL";

export const GET_PROFILE_DRIVER_VEHICLE_DOCUMENT_SETTINGS =
  "profile/GET_PROFILE_DRIVER_VEHICLE_DOCUMENT_SETTINGS";
export const SET_PROFILE_DRIVER_VEHICLE_DOCUMENT_SETTINGS =
  "profile/SET_PROFILE_DRIVER_VEHICLE_DOCUMENT_SETTINGS";

export const SHOW_PROFILE_DRIVER_UPLOAD_DOCUMENTS_MODAL =
  "profile/SHOW_PROFILE_DRIVER_UPLOAD_DOCUMENTS_MODAL";
export const HIDE_PROFILE_DRIVER_UPLOAD_DOCUMENTS_MODAL =
  "profile/HIDE_PROFILE_DRIVER_UPLOAD_DOCUMENTS_MODAL";

export const PROFILE_DRIVER_UPLOAD_VEHICLE_DOCUMENT =
  "profile/PROFILE_DRIVER_UPLOAD_VEHICLE_DOCUMENT";
export const PROFILE_DRIVER_GET_VEHICLE_DOCUMENT =
  "profile/PROFILE_DRIVER_GET_VEHICLE_DOCUMENT";
export const SET_PROFILE_VEHICLE_DOCUMENTS =
  "profile/SET_PROFILE_VEHICLE_DOCUMENTS";
export const PROFILE_DRIVER_VIEW_VEHICLE_DOCUMENT =
  "profile/PROFILE_DRIVER_VIEW_VEHICLE_DOCUMENT";
export const PROFILE_DRIVER_DOWNLOAD_VEHICLE_DOCUMENT =
  "profile/PROFILE_DRIVER_DOWNLOAD_VEHICLE_DOCUMENT";
export const PROFILE_DRIVER_DELETE_VEHICLE_DOCUMENT =
  "profile/PROFILE_DRIVER_DELETE_VEHICLE_DOCUMENT";

export const GET_PROFILE_STATES = "pay-citation/GET_PROFILE_STATES";
export const SET_PROFILE_STATES = "pay-citation/SET_PROFILE_STATES";
export const GET_PROFILE_VEHICLE_MAKE_STATES =
  "pay-citation/GET_PROFILE_VEHICLE_MAKE_STATES";
export const SET_PROFILE_VEHICLE_MAKE_STATES =
  "pay-citation/SET_PROFILE_VEHICLE_MAKE_STATES";

export const GET_PROFILE_VEHICLE_DETAILS =
  "profile/GET_PROFILE_VEHICLE_DETAILS";
export const SET_PROFILE_VEHICLE_DETAILS =
  "profile/SET_PROFILE_VEHICLE_DETAILS";

export const GET_ACCOUNT_VEHICLE_DETAILS = "profile/GET_ACCOUNT_VEHICLE_DETAILS";
export const SET_ACCOUNT_VEHICLE_DETAILS = "profile/SET_ACCOUNT_VEHICLE_DETAILS"

export const UPDATE_PROFILE_VEHICLE_ACTIVATE_DEACTIVATE =
  "profile/UPDATE_PROFILE_VEHICLE_ACTIVATE_DEACTIVATE";

export const PROFILE_DRIVER_UPDATE_PASSWORD =
  "profile/PROFILE_DRIVER_UPDATE_PASSWORD";

export const GET_PROFILE_EMAIL_DETAILS = "profile/GET_PROFILE_EMAIL_DETAILS";
export const SET_PROFILE_EMAIL_DETAILS = "profile/SET_PROFILE_EMAIL_DETAILS";
export const UPDATE_PROFILE_EMAIL_ACTIVATE_DEACTIVATE =
  "profile/UPDATE_PROFILE_EMAIL_ACTIVATE_DEACTIVATE";

export const GET_PROFILE_ADDRESS_DETAILS =
  "profile/GET_PROFILE_ADDRESS_DETAILS";
export const SET_PROFILE_ADDRESS_DETAILS =
  "profile/SET_PROFILE_ADDRESS_DETAILS";
export const UPDATE_PROFILE_ADDRESS_ACTIVATE_DEACTIVATE =
  "profile/UPDATE_PROFILE_ADDRESS_ACTIVATE_DEACTIVATE";

export const GET_PROFILE_PHONE_DETAILS = "profile/GET_PROFILE_PHONE_DETAILS";
export const SET_PROFILE_PHONE_DETAILS = "profile/SET_PROFILE_PHONE_DETAILS";
export const UPDATE_PROFILE_PHONE_ACTIVATE_DEACTIVATE =
  "profile/UPDATE_PROFILE_PHONE_ACTIVATE_DEACTIVATE";

export const GET_REVIEW_AND_ORDER_EDITOR_DATA =
  "profile/GET_REVIEW_AND_ORDER_EDITOR_DATA";
export const SET_REVIEW_AND_ORDER_EDITOR_DATA =
  "profile/SET_REVIEW_AND_ORDER_EDITOR_DATA";

export const GET_MY_ACCOUNT_EDITOR_DATA = "profile/GET_MY_ACCOUNT_EDITOR_DATA";
export const SET_MY_ACCOUNT_EDITOR_DATA = "profile/SET_MY_ACCOUNT_EDITOR_DATA";

export const GET_PAYMENT_PAGE_EDITOR_DATA =
  "profile/GET_PAYMENT_PAGE_EDITOR_DATA";
export const SET_PAYMENT_PAGE_EDITOR_DATA =
  "profile/SET_PAYMENT_PAGE_EDITOR_DATA";

export const GET_CHECKBOX_AGREEMENT_TEXT_EDITOR_DATA =
  "profile/GET_CHECKBOX_AGREEMENT_TEXT_EDITOR_DATA";
export const SET_CHECKBOX_AGREEMENT_TEXT_EDITOR_DATA =
  "profile/SET_CHECKBOX_AGREEMENT_TEXT_EDITOR_DATA";

export const GET_ORDER_COMPLETE_PAGE_EDITOR_DATA =
  "profile/GET_ORDER_COMPLETE_PAGE_EDITOR_DATA";
export const SET_ORDER_COMPLETE_PAGE_EDITOR_DATA =
  "profile/SET_ORDER_COMPLETE_PAGE_EDITOR_DATA";

export const GET_CITATION_INFORMATION_EDITOR_DATA =
  "profile/GET_CITATION_INFORMATION_EDITOR_DATA";
export const SET_CITATION_INFORMATION_EDITOR_DATA =
  "profile/SET_CITATION_INFORMATION_EDITOR_DATA";

export const GET_CITATION_DETAILS_PAGE_EDITOR_DATA =
  "profile/GET_CITATION_DETAILS_PAGE_EDITOR_DATA";
export const SET_CITATION_DETAILS_PAGE_EDITOR_DATA =
  "profile/SET_CITATION_DETAILS_PAGE_EDITOR_DATA";

export const GET_PAYMENT_TEXT_CITATION_EDITOR_DATA =
  "profile/GET_PAYMENT_TEXT_CITATION_EDITOR_DATA";
export const SET_PAYMENT_TEXT_CITATION_EDITOR_DATA =
  "profile/SET_PAYMENT_TEXT_CITATION_EDITOR_DATA";

export const GET_PAYMENT_ACCEPTED_TEXT_CITATION_EDITOR_DATA =
  "profile/GET_PAYMENT_ACCEPTED_TEXT_CITATION_EDITOR_DATA";
export const SET_PAYMENT_ACCEPTED_TEXT_CITATION_EDITOR_DATA =
  "profile/SET_PAYMENT_ACCEPTED_TEXT_CITATION_EDITOR_DATA";

export const GET_APPEAL_FINE_HEADER_EDITOR_DATA =
  "profile/GET_APPEAL_FINE_HEADER_EDITOR_DATA";
export const SET_APPEAL_FINE_HEADER_EDITOR_DATA =
  "profile/SET_APPEAL_FINE_HEADER_EDITOR_DATA";

export const GET_TERMS_OF_USES_EDITOR_DATA =
  "profile/GET_TERMS_OF_USES_EDITOR_DATA";
export const SET_TERMS_OF_USES_EDITOR_DATA =
  "profile/SET_TERMS_OF_USES_EDITOR_DATA";

export const GET_NEW_ORDER_PERMIT_DATA = "profile/GET_NEW_ORDER_PERMIT_DATA";
export const SET_NEW_ORDER_PERMIT_DATA = "profile/SET_NEW_ORDER_PERMIT_DATA";

export const GET_STATES = "profile/GET_STATES";
export const getStates = (data) => {
  return {
    type: GET_STATES,
    payload: data,
  };
};
export const SET_STATES = "profile/SET_STATES";
export const setStates = (data) => {
  return {
    type: SET_STATES,
    payload: data,
  };
};

export const showProfileDriverUpdateUserNameModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_UPDATE_USERNAME_MODAL,
  };
};

export const hideProfileDriverUpdateUserNameModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_UPDATE_USERNAME_MODAL,
  };
};
export const profileDriverUpdatePassword = (data) => {
  return {
    type: PROFILE_DRIVER_UPDATE_PASSWORD,
    payload: data,
  };
};

export const getProfileStates = (data) => {
  return {
    type: GET_PROFILE_STATES,
    payload: data,
  };
};
export const setProfileStates = (data) => {
  return {
    type: SET_PROFILE_STATES,
    payload: data,
  };
};
export const getProfileVehicleMakeStates = () => {
  return {
    type: GET_PROFILE_VEHICLE_MAKE_STATES,
  };
};
export const setProfileVehicleMakeStates = (data) => {
  return {
    type: SET_PROFILE_VEHICLE_MAKE_STATES,
    payload: data,
  };
};

export const showProfileDriverBirthadayModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_BIRTHDAY_MODAL,
  };
};

export const hideProfileDriverBirthadayModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_BIRTHDAY_MODAL,
  };
};

export const showProfileDriverLicenseModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_LICENSE_MODAL,
  };
};

export const hideProfileDriverLicenseModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_LICENSE_MODAL,
  };
};

export const showProfileDriverEmailModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_EMAIL_MODAL,
  };
};

export const hideProfileDriverEmailModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_EMAIL_MODAL,
  };
};

export const showProfileDriverAddressModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_ADDRESS_MODAL,
  };
};

export const hideProfileDriverAddressModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_ADDRESS_MODAL,
  };
};

export const showProfileDriverPhoneModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_PHONE_MODAL,
  };
};

export const hideProfileDriverPhoneModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_PHONE_MODAL,
  };
};

export const showProfileDriverVehicleOptionsModal = (vehicle) => {
  return {
    type: SHOW_PROFILE_DRIVER_VEHICLE_OPTIONS_MODAL,
    payload: vehicle,
  };
};

export const hideProfileDriverVehicleOptionsModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_VEHICLE_OPTIONS_MODAL,
  };
};

export const showProfileDriverEmailOptionsModal = (email) => {
  return {
    type: SHOW_PROFILE_DRIVER_EMAIL_OPTIONS_MODAL,
    payload: email,
  };
};

export const hideProfileDriverEmailOptionsModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_EMAIL_OPTIONS_MODAL,
  };
};

export const showProfileDriverAddressOptionsModal = (address) => {
  return {
    type: SHOW_PROFILE_DRIVER_ADDRESS_OPTIONS_MODAL,
    payload: address,
  };
};

export const hideProfileDriverAddressOptionsModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_ADDRESS_OPTIONS_MODAL,
  };
};

export const showProfileDriverPhoneOptionsModal = (phone) => {
  return {
    type: SHOW_PROFILE_DRIVER_PHONE_OPTIONS_MODAL,
    payload: phone,
  };
};

export const hideProfileDriverPhoneOptionsModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_PHONE_OPTIONS_MODAL,
  };
};
export const showProfileDriverAddVehicleModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_ADD_VEHICLE_MODAL,
  };
};
export const hideProfileDriverAddVehicleModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_ADD_VEHICLE_MODAL,
  };
};
export const showProfileDriverManageVehicleseModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_MANAGE_VEHICLE_MODAL,
  };
};
export const hideProfileDriverManageVehicleseModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_MANAGE_VEHICLE_MODAL,
  };
};

export const profileDriverAddNewVehicle = (data) => {
  return {
    type: PROFILE_DRIVER_ADD_NEW_VEHICLE,
    payload: data,
  };
};

export const profileDriverAddNewVehicleWithDocuments = (data) => {
  return {
    type: PROFILE_DRIVER_ADD_NEW_VEHICLE_WITH_DOCUMENTS,
    payload: data,
  };
};

// Edit Vehicle Value
export const profileDriverEditVehicle = (data) => {
  return {
    type: PROFILE_DRIVER_EDIT_VEHICLE,
    payload: data,
  };
};

export const profileDriverAddNewEmail = (data) => {
  return {
    type: PROFILE_DRIVER_ADD_NEW_EMAIL,
    payload: data,
  };
};

export const profileDriverAddNewAddress = (data) => {
  return {
    type: PROFILE_DRIVER_ADD_NEW_ADDRESS,
    payload: data,
  };
};

export const profileDriverAddNewBillingAddress = (data) => {
  return {
    type: PROFILE_DRIVER_ADD_NEW_BILLING_ADDRESS,
    payload: data,
  };
};

export const profileDriverAddNewPhone = (data) => {
  return {
    type: PROFILE_DRIVER_ADD_NEW_PHONE,
    payload: data,
  };
};

export const profileDriverEditVehicleApi = (data) => {
  return {
    type: PROFILE_DRIVER_EDIT_VEHICLE_API,
    payload: data,
  };
};

export const profileDriverEditEmailApi = (data) => {
  return {
    type: PROFILE_DRIVER_EDIT_EMAIL_API,
    payload: data,
  };
};
// delete vehicle
export const profileDriverDeleteVehicleApi = (data) => {
  return {
    type: PROFILE_DRIVER_DELETE_VEHICLE_API,
    payload: data,
  };
};
// delete email
export const profileDriverDeleteEmailApi = (data) => {
  return {
    type: PROFILE_DRIVER_DELETE_EMAIL_API,
    payload: data,
  };
};

// Get style on driver portal

export const GetprofileDriverStylingApi = (data) => {
  return {
    type: PROFILE_DRIVER_GET_STYLING_API,
    payload: data,
  };
};

export const SetprofileDriverStylingApi = (data) => {
  return {
    type: PROFILE_DRIVER_SET_STYLING_API,
    payload: data,
  };
};
// Update Birthday

export const profileDriverEditDOBApi = (data) => {
  return {
    type: PROFILE_DRIVER_EDIT_DOB_API,
    payload: data,
  };
};

export const profileDriverEditAddressApi = (data) => {
  return {
    type: PROFILE_DRIVER_EDIT_ADDRESS_API,
    payload: data,
  };
};
export const profileDriverEditPhoneApi = (data) => {
  return {
    type: PROFILE_DRIVER_EDIT_PHONE_API,
    payload: data,
  };
};

export const showProfileDriverEditVehicleModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_EDIT_VEHICLE_MODAL,
  };
};

export const hideProfileDriverEditVehicleModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_EDIT_VEHICLE_MODAL,
  };
};
export const hideProfileDriverDeleteVehicleModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_DELETE_VEHICLE_MODAL,
  };
};
export const showProfileDriverDeleteVehicleModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_DELETE_VEHICLE_MODAL,
  };
};
export const showProfileDriverDeleteEmailModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_DELETE_EMAIL_MODAL,
  };
};

export const showProfileDriverDeleteAddressModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_DELETE_ADDRESS_MODAL,
  };
};

export const hideProfileDriverDeleteAddressModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_DELETE_EMAIL_MODAL,
  };
};

export const showProfileDriverEditEmailModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_EDIT_EMAIL_MODAL,
  };
};

export const hideProfileDriverEditEmailModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_EDIT_EMAIL_MODAL,
  };
};
export const hideProfileDriverDeleteEmailModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_DELETE_EMAIL_MODAL,
  };
};
export const showProfileDriverEditAddressModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_EDIT_ADDRESS_MODAL,
  };
};

export const hideProfileDriverEditAddressModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_EDIT_ADDRESS_MODAL,
  };
};

export const showProfileDriverEditPhoneModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_EDIT_PHONE_MODAL,
  };
};

export const hideProfileDriverEditPhoneModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_EDIT_PHONE_MODAL,
  };
};

export const showProfileDriverVehicleDocumentsModal = (vehicle) => {
  return {
    type: SHOW_PROFILE_DRIVER_VEHICLE_DOCUMENTS_MODAL,
    payload: vehicle,
  };
};

export const hideProfileDriverVehicleDocumentsModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_VEHICLE_DOCUMENTS_MODAL,
  };
};

export const showProfileDriverUploadDocumentsModal = () => {
  return {
    type: SHOW_PROFILE_DRIVER_UPLOAD_DOCUMENTS_MODAL,
  };
};

export const hideProfileDriverUploadDocumentsModal = () => {
  return {
    type: HIDE_PROFILE_DRIVER_UPLOAD_DOCUMENTS_MODAL,
  };
};

export const getProfileVehicleDocumentSettings = (data) => {
  return {
    type: GET_PROFILE_DRIVER_VEHICLE_DOCUMENT_SETTINGS,
    payload: data,
  };
};

export const setProfileVehicleDocumentSettings = (data) => {
  return {
    type: SET_PROFILE_DRIVER_VEHICLE_DOCUMENT_SETTINGS,
    payload: data,
  };
};

export const profileDriverUploadVehicleDocument = (data) => {
  return {
    type: PROFILE_DRIVER_UPLOAD_VEHICLE_DOCUMENT,
    payload: data,
  };
};

export const getProfileVehicleDocuments = (data) => {
  return {
    type: PROFILE_DRIVER_GET_VEHICLE_DOCUMENT,
    payload: data,
  };
};

export const setProfileVehicleDocuments = (data) => {
  return {
    type: SET_PROFILE_VEHICLE_DOCUMENTS,
    payload: data,
  };
};

export const profileDriverViewVehicleDocument = (data) => {
  return {
    type: PROFILE_DRIVER_VIEW_VEHICLE_DOCUMENT,
    payload: data,
  };
};

export const profileDriverDownloadVehicleDocument = (data) => {
  return {
    type: PROFILE_DRIVER_DOWNLOAD_VEHICLE_DOCUMENT,
    payload: data,
  };
};

export const profileDriverDeleteVehicleDocument = (data) => {
  return {
    type: PROFILE_DRIVER_DELETE_VEHICLE_DOCUMENT,
    payload: data,
  };
};

export const getProfileVehicleDetails = (data) => {
  return {
    type: GET_PROFILE_VEHICLE_DETAILS,
    payload: data,
  };
};

export const setProfileVehicleDetails = (data) => {
  return {
    type: SET_PROFILE_VEHICLE_DETAILS,
    payload: data,
  };
};

export const getAccountVehicleDetails = (data) => {
  return {
    type: GET_ACCOUNT_VEHICLE_DETAILS,
    payload: data,
  };
};

export const setAccountVehicleDetails = (data) => {
  return {
    type: SET_ACCOUNT_VEHICLE_DETAILS,
    payload: data,
  };
};

export const updateProfileVehicleActivateDeactivate = (data) => {
  return {
    type: UPDATE_PROFILE_VEHICLE_ACTIVATE_DEACTIVATE,
    payload: data,
  };
};

//Activate Deactivate for Email

export const getProfileEmailDetails = (data) => {
  return {
    type: GET_PROFILE_EMAIL_DETAILS,
    payload: data,
  };
};

export const setProfileEmailDetails = (data) => {
  return {
    type: SET_PROFILE_EMAIL_DETAILS,
    payload: data,
  };
};

export const updateProfileEmailActivateDeactivate = (data) => {
  return {
    type: UPDATE_PROFILE_EMAIL_ACTIVATE_DEACTIVATE,
    payload: data,
  };
};
//Activate Deactivate for Address

export const getProfileAddressDetails = (data) => {
  return {
    type: GET_PROFILE_ADDRESS_DETAILS,
    payload: data,
  };
};

export const setProfileAddressDetails = (data) => {
  return {
    type: SET_PROFILE_ADDRESS_DETAILS,
    payload: data,
  };
};

export const updateProfileAddressActivateDeactivate = (data) => {
  return {
    type: UPDATE_PROFILE_ADDRESS_ACTIVATE_DEACTIVATE,
    payload: data,
  };
};
//Activate Deactivate for Address

export const getProfilePhoneDetails = (data) => {
  return {
    type: GET_PROFILE_PHONE_DETAILS,
    payload: data,
  };
};

export const setProfilePhoneDetails = (data) => {
  return {
    type: SET_PROFILE_PHONE_DETAILS,
    payload: data,
  };
};

export const updateProfilePhoneActivateDeactivate = (data) => {
  return {
    type: UPDATE_PROFILE_PHONE_ACTIVATE_DEACTIVATE,
    payload: data,
  };
};

export const getMyAccountEditorDataAction = (data) => {
  return {
    type: GET_MY_ACCOUNT_EDITOR_DATA,
    payload: data,
  };
};

export const setMyAccountEditorDataAction = (data) => {
  return {
    type: SET_MY_ACCOUNT_EDITOR_DATA,
    payload: data,
  };
};

export const getReviewAndOrderEditorDataAction = (data) => {
  return {
    type: GET_REVIEW_AND_ORDER_EDITOR_DATA,
    payload: data,
  };
};

export const setReviewAndOrderEditorDataAction = (data) => {
  return {
    type: SET_REVIEW_AND_ORDER_EDITOR_DATA,
    payload: data,
  };
};

export const getPaymentPageEditorDataAction = (data) => {
  return {
    type: GET_PAYMENT_PAGE_EDITOR_DATA,
    payload: data,
  };
};

export const setPaymentPageEditorDataAction = (data) => {
  return {
    type: SET_PAYMENT_PAGE_EDITOR_DATA,
    payload: data,
  };
};

export const getCheckboxAgreementTextEditorDataAction = (data) => {
  return {
    type: GET_CHECKBOX_AGREEMENT_TEXT_EDITOR_DATA,
    payload: data,
  };
};

export const setCheckboxAgreementTextEditorDataAction = (data) => {
  return {
    type: SET_CHECKBOX_AGREEMENT_TEXT_EDITOR_DATA,
    payload: data,
  };
};

export const getOrderCompletePageEditorDataAction = (data) => {
  return {
    type: GET_ORDER_COMPLETE_PAGE_EDITOR_DATA,
    payload: data,
  };
};

export const setOrderCompletePageEditorDataAction = (data) => {
  return {
    type: SET_ORDER_COMPLETE_PAGE_EDITOR_DATA,
    payload: data,
  };
};

export const getCitationInformationEditorDataAction = (data) => {
  return {
    type: GET_CITATION_INFORMATION_EDITOR_DATA,
    payload: data,
  };
};

export const setCitationInformationEditorDataAction = (data) => {
  return {
    type: SET_CITATION_INFORMATION_EDITOR_DATA,
    payload: data,
  };
};
// new order permit data //
export const getNewPermitOrderDataAction = (data) => {
  return {
    type: GET_NEW_ORDER_PERMIT_DATA,
    payload: data,
  };
};

export const setNewPermitOrderDataAction = (data) => {
  return {
    type: SET_NEW_ORDER_PERMIT_DATA,
    payload: data,
  };
};
// new order permit end-data //
export const getCitationDetailsPageEditorDataAction = (data) => {
  return {
    type: GET_CITATION_DETAILS_PAGE_EDITOR_DATA,
    payload: data,
  };
};

export const setCitationDetailsPageEditorDataAction = (data) => {
  return {
    type: SET_CITATION_DETAILS_PAGE_EDITOR_DATA,
    payload: data,
  };
};

export const getPaymentTextCitationEditorDataAction = (data) => {
  return {
    type: GET_PAYMENT_TEXT_CITATION_EDITOR_DATA,
    payload: data,
  };
};

export const setPaymentTextCitationEditorDataAction = (data) => {
  return {
    type: SET_PAYMENT_TEXT_CITATION_EDITOR_DATA,
    payload: data,
  };
};

export const getPaymentAcceptedTextCitationEditorDataAction = (data) => {
  return {
    type: GET_PAYMENT_ACCEPTED_TEXT_CITATION_EDITOR_DATA,
    payload: data,
  };
};

export const setPaymentAcceptedTextCitationEditorDataAction = (data) => {
  return {
    type: SET_PAYMENT_ACCEPTED_TEXT_CITATION_EDITOR_DATA,
    payload: data,
  };
};

export const getAppealFineHeaderEditorDataAction = (data) => {
  return {
    type: GET_APPEAL_FINE_HEADER_EDITOR_DATA,
    payload: data,
  };
};

export const setAppealFineHeaderEditorDataAction = (data) => {
  return {
    type: SET_APPEAL_FINE_HEADER_EDITOR_DATA,
    payload: data,
  };
};

export const getTermsOfUsesEditorDataAction = (data) => {
  return {
    type: GET_TERMS_OF_USES_EDITOR_DATA,
    payload: data,
  };
};

export const setTermsOfUsesEditorDataAction = (data) => {
  return {
    type: SET_TERMS_OF_USES_EDITOR_DATA,
    payload: data,
  };
};
